// extracted by mini-css-extract-plugin
export var button = "dialog-module--button--d891f";
export var dialog = "dialog-module--dialog--54e3e";